(function () {
  const ROOT_ID = 'SinglesCollectionTools';

  function normalize(s) { return (s || '').toString().trim().toLowerCase(); }

  function filterSinglesTypes() {
    document.querySelectorAll('#main-collection-filters .sidebarBlock').forEach(function (block) {
      const heading = normalize(block.querySelector('.sidebarBlock-heading .facets__text')?.textContent);
      if (heading !== 'product type' && heading !== 'type') return;
      block.querySelectorAll('li.facets__item, li.list-menu__item').forEach(function (item) {
        const input = item.querySelector('input[type="checkbox"]');
        const value = normalize(input?.value || item.dataset.value || item.textContent);
        item.style.display = value.includes('singles') ? '' : 'none';
      });
    });
  }

  function applyTitleFilter() {
    const input = document.querySelector('[data-singles-title-search]');
    if (!input) return;
    const query = normalize(input.value);
    let visible = 0;
    document.querySelectorAll('#main-collection-product-grid > li.product').forEach(function (item) {
      const titleEl = item.querySelector('.card-title');
      const title = normalize(titleEl?.dataset.productTitle || titleEl?.textContent);
      const show = !query || title.includes(query);
      item.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    const count = document.querySelector('[data-singles-title-count]');
    if (count) count.textContent = query ? visible + ' matching product' + (visible === 1 ? '' : 's') + ' on this page' : '';
  }

  function injectSearch() {
    if (document.getElementById(ROOT_ID)) return;
    const sidebar = document.querySelector('#halo-sidebar .halo-sidebar-wrapper');
    if (!sidebar) return;
    const box = document.createElement('div');
    box.id = ROOT_ID;
    box.className = 'sidebarBlock singles-title-filter';
    box.innerHTML = '<h2 class="sidebarBlock-heading"><span class="facets__text">Search by title</span></h2>' +
      '<div class="sidebarBlock-content" style="padding-top:12px">' +
      '<input type="search" data-singles-title-search class="form-input" placeholder="Enter card name or keywords" autocomplete="off" aria-label="Search products by title">' +
      '<div data-singles-title-count style="font-size:12px;margin-top:7px;opacity:.75"></div>' +
      '</div>';
    sidebar.insertBefore(box, sidebar.firstChild);
    box.querySelector('input').addEventListener('input', applyTitleFilter);
  }

  function refresh() {
    injectSearch();
    filterSinglesTypes();
    applyTitleFilter();
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  const observer = new MutationObserver(function () { window.clearTimeout(window.__singlesRefresh); window.__singlesRefresh = window.setTimeout(refresh, 80); });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
